import { ROUTES } from "src/consts/routes";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { Box, Divider, Stack } from "@mui/material";
import { ElectricalServices, Tick } from "src/assets";
import SubmitButton from "src/components/Shared/SubmitButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import FormContainer from "src/components/Displays/FormContainer";

const Status = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const oem = searchParams.get("oem") || "";

  const getOemName = () => {
    let oemName = oem;
    switch (oem) {
      case "VIESSMANN_API":
        oemName = "Viessmann via API";
        break;
      case "SUNGROW_ISOLARCLOUD":
        oemName = "Sungrow via iSolarcloud";
        break;
      case "ENPH_VPPAPI":
        oemName = "Enphase via VPP API";
        break;
      default:
        break;
    }
    return oemName;
  };

  const goToCalculator = () => {
    navigate(ROUTES.PV_SETUP);
  };

  return (
    <Stack gap={5}>
      <Text
        text={t("page.selfOnboardingStatus.pageTitle")}
        sx={(theme) => ({
          fontSize: "32px",
          lineHeight: "35px",
          fontFamily: "isonType",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Text
        text={t("page.selfOnboardingStatus.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "24px",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Box sx={{ maxWidth: { xs: "100%", sm: "362px" } }}>
        <FormContainer onSubmit={() => {}}>
          <Stack gap={1} direction={"row"} alignItems={"center"}>
            <ElectricalServices />
            <Text
              text={t("page.selfOnboardingStatus.formTitle")}
              sx={(theme) => ({
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
                color: theme.palette.mainFont.primary,
              })}
            />
          </Stack>

          <Stack sx={{ marginTop: 6, marginBottom: 3 }}>
            <Stack
              direction={"column"}
              sx={(theme) => ({
                borderRadius: 3,
                bgcolor: "#C6FFB2",
                overflow: "hidden",
                border: "1px solid #009A22",
              })}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                sx={(theme) => ({
                  justifyContent: "space-between",
                })}
              >
                <Stack pl={3} gap={2} pb={10} pt={2}>
                  <Text
                    sx={(theme) => ({
                      color: "#222",
                      fontSize: "12px",
                      fontWeight: "400",
                      lineHeight: "18px",
                    })}
                    text={t("page.selfOnboardingStatus.selectedWallbox")}
                  />

                  <Text
                    sx={{
                      color: "#1B5F40",
                      fontSize: "24px",
                      fontWeight: "700",
                      lineHeight: "28px",
                    }}
                    text={getOemName()}
                  />
                </Stack>
              </Stack>

              <Stack
                justifyContent={"center"}
                alignItems={"center"}
                direction={"column"}
                gap={1}
                sx={(theme) => ({
                  m: 0.5,
                  mt: -8,
                  padding: "8px 16px",
                  borderRadius: 3,
                  backdropFilter: "blur(3px)",
                  border: "1px solid #48BD57",
                  bgcolor: "rgba(0, 154, 34, 0.64)",
                })}
              >
                <Stack direction={"row"} gap={1}>
                  <Tick fill="#FFF" />
                  <Text
                    text={`Kompatibel`}
                    sx={{
                      color: "#fff",
                      fontSize: "11px",
                      fontWeight: 700,
                      lineHeight: "15px",
                    }}
                  />
                </Stack>

                <Divider
                  sx={{
                    bgcolor: "rgba(255, 255, 255, 0.6)",
                    height: "1px",
                    width: "100%",
                    my: 1,
                  }}
                />

                <Text
                  text={`Diese Hardware ist kompatibel.`}
                  sx={{
                    color: "#FFF",
                    lineHeight: "15px",
                    fontSize: "11px",
                    fontWeight: 400,
                  }}
                />
              </Stack>
            </Stack>
          </Stack>

          <SubmitButton
            fullWidth
            onClick={goToCalculator}
            buttonText={t("page.selfOnboardingStatus.button")}
            sx={(theme) => ({
              fontSize: "14px",
              color: theme.palette.mainFont.primary,
            })}
          />
        </FormContainer>
      </Box>
    </Stack>
  );
};

export default Status;
